import { Link, Head } from '@inertiajs/react';
import { PageProps } from '@/types';
import { Icon } from '@iconify/react';
import Header from '@/Layouts/Partials/Header';
import Footer from '@/Layouts/Partials/Footer';
import { SettingModel } from '@/types/models/setting';
import FrontLayout from '@/Layouts/FrontLayout';
import { useEffect, useState } from 'react';
import HeroSlider from '@/Components/Homepage/HeroSlider';
import SliderWithDescription from '@/Components/Homepage/SliderWithDescription';
import ChoiceOnMedal from '@/Components/Homepage/ChoiceOnMedal';
import LandscapeWithBox from '@/Components/Homepage/LandscapeWithBox';
import IconsWithTexts from '@/Components/Homepage/IconsWithTexts';
import InvestmentOnMedal from '@/Components/Homepage/InvestmentOnMedal';
import FindApartment from '@/Components/Homepage/FindApartment';
import Facilities from '@/Components/Homepage/Facilities';
import ApartmentSearch from '@/Components/Homepage/ApartmentSearch';
import { SearchEngineData } from '@/types/searchEngineData';
import { GalleryModel } from '@/types/models/gallery';
import GallerySlider from '@/Components/Homepage/GallerySlider';
import News from '@/Components/Homepage/News';
import { PostModel } from '@/types/models/post';
import AboutInvestor from '@/Components/Homepage/AboutInvestor';
import ContactForm from '@/Components/Universal/ContactForm';
import InvestmentLocation from '@/Components/Homepage/InvestmentLocation';
import SearchEngine3D from '@/Components/Apartments/SearchEngine3D';
import AdvPopup from '@/Components/Homepage/AdvPopup';
import { AdvPopupType } from '@/types/components/advPopupType';
import AvailableInSell from '@/Components/Homepage/AvailableInSell';
import PlaceAdvantages from '@/Components/Homepage/PlaceAdvantages';
import SearchWithRedirect2D from '@/Components/Apartments/SearchWithRedirect2D';
import { HighlightedApartment } from '@/Components/Homepage/HighlightedApartment';
import HeroFeatures from '@/Components/Homepage/HeroFeatures';
import RecommendedApartments from '@/Components/Homepage/RecommendedApartments';
import SpecialOffers from '@/Components/Homepage/SpecialOffers';
import { ApartmentModel } from '@/types/models/apartment';

interface Slide {
    image: string;
    heading: string;
    text: string;
    buttonLink: string;
    buttonText: string;
    buttonLink2?: string;
    buttonText2?: string;
}

export default function Index({ sliderSetting, searchEngineParams, galleryImages, news, popup, amountOfBuildingA, amountOfBuildingB, recommendedApartments, promotions }: PageProps<{
    sliderSetting: SettingModel, searchEngineParams: SearchEngineData, galleryImages: GalleryModel[],
    news: PostModel[],
    popup: SettingModel,
    amountOfBuildingA: number,
    amountOfBuildingB: number,
    recommendedApartments: ApartmentModel[],
    promotions: PostModel[],
}>) {
    const [parsedContent, setParsedContent] = useState<Slide[]>();
    const [parsedPopup, setParsedPopup] = useState<AdvPopupType>();

    useEffect(() => {
        if (popup?.content != '') {
            setParsedPopup(JSON.parse(popup.content))
        }
    }, [popup])

    useEffect(() => {
        if (sliderSetting?.content != '') {
            setParsedContent(JSON.parse(sliderSetting.content))
        }
    }, [sliderSetting])

    return (
        <>
            <Head title="Osiedle Kusocińskiego">
                <meta name='description' content='Osiedle Kusocińskiego' />
            </Head>
            <FrontLayout>
                <HeroSlider slides={parsedContent} />
                <HeroFeatures />
                <RecommendedApartments apartments={recommendedApartments} />
                <AvailableInSell estateA={amountOfBuildingA} estateB={amountOfBuildingB} />
                <HighlightedApartment />
                <SpecialOffers posts={promotions} />

                <SliderWithDescription />
                {/* <SearchWithRedirect2D additionalButtons/> */}
                <SearchEngine3D additionalButtons />
                <ChoiceOnMedal />

                <PlaceAdvantages />
                <LandscapeWithBox />
                {/* <IconsWithTexts /> */}
                <FindApartment />
                <InvestmentOnMedal />
                <Facilities />
                <InvestmentLocation />
                {/* <ApartmentSearch searchEngineParams={searchEngineParams}/> */}
                <GallerySlider images={galleryImages} />
                <News posts={news} />
                <AboutInvestor />
                <ContactForm />

                <AdvPopup {...parsedPopup} />
            </FrontLayout>
        </>
    );
}
